import { render } from "./KPIItem.vue?vue&type=template&id=00627bd1&scoped=true"
import script from "./KPIItem.vue?vue&type=script&lang=js"
export * from "./KPIItem.vue?vue&type=script&lang=js"

import "./KPIItem.vue?vue&type=style&index=0&id=00627bd1&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00627bd1"]])

export default __exports__